import { extensionId } from "@/utils/constants";

const CHROME_STORE_URL = `https://chrome.google.com/webstore/detail/${extensionId}`;

/**
 * Exposes a few site actions to supporting browsers (WebMCP).
 * @returns {AbortController | null}
 */
export function registerWebMcpTools() {
  if (typeof navigator === "undefined") return null;
  const modelContext = navigator.modelContext;
  if (!modelContext || typeof modelContext.registerTool !== "function") {
    return null;
  }

  const controller = new AbortController();
  const options = { signal: controller.signal };

  try {
    modelContext.registerTool(
      {
        name: "open_help",
        description: "Opens the Palette help page (palette.site/help).",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false,
        },
        async execute() {
          window.location.assign("/help");
          return { opened: "/help" };
        },
      },
      options,
    );
  } catch (e) {
    console.warn("WebMCP open_help:", e);
  }

  try {
    modelContext.registerTool(
      {
        name: "open_blog",
        description: "Opens the Palette blog at /blog/.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false,
        },
        async execute() {
          window.location.assign("/blog/");
          return { opened: "/blog/" };
        },
      },
      options,
    );
  } catch (e) {
    console.warn("WebMCP open_blog:", e);
  }

  try {
    modelContext.registerTool(
      {
        name: "open_chrome_store_listing",
        description: "Opens the Site Palette extension page in the Chrome Web Store.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false,
        },
        async execute() {
          window.open(CHROME_STORE_URL, "_blank", "noopener,noreferrer");
          return { opened: CHROME_STORE_URL };
        },
      },
      options,
    );
  } catch (e) {
    console.warn("WebMCP open_chrome_store_listing:", e);
  }

  return controller;
}
